let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d0Fxy")).then(() => parcelRequire('7WiGm'));